export default __webpack_public_path__ + "static/media/ic_cart_active_TP.26bfd0d4.svg";